<div class="header-container flex h-[80px] w-full bg-input-grey">
  <div class="menu-container ml-[41px] pt-[11px] mr-[10px] w-full">
    <p-menubar [model]="items">
      <ng-template pTemplate="start">
        <div class="logo-container mr-[20px] w-[197px] h-[36px]">
          <button (click)="goHome()" class="border-0 cursor-pointer">
            <img
              src="assets/images/nlb_logo.svg"
              alt="NLB logo"
            />
          </button>
        </div>
      </ng-template>
      <ng-template pTemplate="item" let-item let-root="root">
        @if (item.hasAccess) {
          <a
            pRipple
            class="flex align-items-center p-menuitem-link"
            [routerLink]="item.routerLink"
            [ngClass]="{ 'p-menuitem-link-active': isActive(item) }"
          >
            <span class="p-menuitem-text ng-star-inserted">{{ item.label }}</span>
          </a>
        }
      </ng-template>
      <ng-template pTemplate="end">
        <div class="user-data-container grid grid-rows-1 grid-flow-col gap-2">
          <div class="mr-3" *ngIf="checkSuperAdminRole() === true">
            <ng-container *ngIf="countries$ | async as countries">
              <p-dropdown
                [options]="countries"
                optionLabel="fullName"
                optionValue="id"
                dataKey="value"
                [(ngModel)]="selectedCountryId"
                (onChange)="changeCountry($event)"
                class="w-full select-field-header"
              ></p-dropdown>
            </ng-container>
          </div>
          @if (isVendorSelectActive) {
            <div class="mr-3">
              <p-dropdown
                [options]="(vendors$ | async) || []"
                optionLabel="name"
                optionValue="guid"
                dataKey="guid"
                [showClear]="isVendorClearActive"
                [(ngModel)]="selectedVendorGuid"
                (onChange)="changeVendor($event)"
                class="w-full select-field-header"
              ></p-dropdown>
            </div>
          }
          <div>

          </div>
          <div>
            <p class="text-purple font-bold m-0">{{ loggedUser }}</p>
          </div>
          <div>
            <p-button
              [link]="true"
              (click)="op.toggle($event)"
              class="user-data-button"
            >
              <i class="s-icon-linear s-icon-arrow-down icon-weight"></i>
            </p-button>
            <p-overlayPanel #op>
              <p-button
                [link]="true"
                [disabled]="!selectedVendorGuid && checkVendorAdminRole()"
                *ngIf="checkSuperAdminRole() || checkCountryAdminRole() || checkVendorAdminRole()"
                (click)="editApplicationSettings()"
                class="user-data-button block"
              >
                <i class="s-icon-linear s-icon-setting-2 icon-weight"></i>
                <span class="ml-[15px]">{{
                  "buttons.appSettings" | transloco
                }}</span>
              </p-button>

              <p-button
                [link]="true"
                (click)="logout()"
                class="user-logout-button block"
              >
                <i class="s-icon-linear s-icon-logout icon-weight"></i>
                <span class="ml-[15px]">
                  {{ "buttons.logout" | transloco }}
                </span>
              </p-button>
            </p-overlayPanel>
          </div>
        </div>
      </ng-template>
    </p-menubar>
  </div>
</div>
